import { AxiosError } from 'axios'
import { ZodError } from 'zod'

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    switch (error.status) {
      case 400:
        return error.response?.data.error
      case 401:
        return 'Unauthorized! Please log in'
      case 403:
        return "You don't have permission to access this resource"
      case 404:
        return 'The requested resource not found!'
      default:
        return 'Error occurred in communication with the service'
    }
  }
  if (error instanceof ZodError) {
    return JSON.parse(error.message)[0].message
  }
  if (error instanceof Error) {
    return error.message
  }

  return 'Unexpected error occurred'
}
